// extracted by mini-css-extract-plugin
export default {"background":"Alert_background__pjQKJ","box":"Alert_box__NeIKc","btns":"Alert_btns__4hkdV"};